import {
  Box,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@agrotoken-tech/ui';
import { PageHeader } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import React from 'react';
import { CreditorCropPledge } from '../components/CropPledge/CreditorCropPledge';
import { DebtorCropPledge } from '../components/CropPledge/DebtorCropPledge';

export const CropPledgePage = () => {
  const { t } = useTranslation();
  const prefixKey = 'cropPledge.page';

  return (
    <Flex direction={'column'} gridRowGap={5}>
      <PageHeader title={t('common.navigation.route.cropPledge')} />
      <Tabs isLazy>
        <Box overflow="auto">
          <TabList gap={8}>
            <Tab minWidth={'fit-content'} px={0}>
              {t(`${prefixKey}.tab.creditor`)}
            </Tab>

            <Tab minWidth={'fit-content'} px={0}>
              {t(`${prefixKey}.tab.debtor`)}
            </Tab>
          </TabList>
        </Box>
        <TabPanels py={6}>
          <TabPanel px={0}>
            <CreditorCropPledge />
          </TabPanel>
          <TabPanel px={0}>
            <DebtorCropPledge />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
};

export default CropPledgePage;
